import axios from "axios";
import { toast } from "react-toastify";

import { store } from "../redux/store";
import { SET_DOCUMENT_URL } from "../redux/actionType";
import { getAuthToken } from "./auth";

const DOC_URL_TTL_MS = 60 * 1000;
const inFlightDocRequests = {};

export const getCachedViewUrl = async (documentId) => {
    if (!documentId) return null;

    const cached = store.getState().ApplicationReducer.documentUrls?.[documentId];
    if (cached?.url && Date.now() - cached.fetchedAt < DOC_URL_TTL_MS) {
        return cached.url;
    }

    if (inFlightDocRequests[documentId]) return inFlightDocRequests[documentId];

    // const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // const authToken = tokens?.token || null;
    const authToken = getAuthToken();
    if (!authToken) return null;

    const request = axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/documents/view-doc/${documentId}`, {
            headers: { 'Authorization': `Bearer ${authToken}`, 'Content-Type': 'application/json' }
        })
        .then((res) => {
            const url = res?.data?.data?.data;
            if (url) {
                store.dispatch({ type: SET_DOCUMENT_URL, payload: { documentId, url, fetchedAt: Date.now() } });
            }
            return url;
        })
        .finally(() => { delete inFlightDocRequests[documentId]; });

    inFlightDocRequests[documentId] = request;
    return request;
};

export const getViewSingleDocumentUrl = async (doc) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    try {
        // const res = await axios.get(
        //     `${process.env.REACT_APP_API_BASE_URL}/documents/view-doc/${doc?.document_id}`,
        //     { headers }
        // );

        // const viewUrl = res?.data?.data?.data;

        // return {
        //     ...doc,
        //     document_url: viewUrl,
        // };
        const viewUrl = await getCachedViewUrl(doc?.document_id);
        return {
            ...doc,
            document_url: viewUrl,
        };
    }
    catch (err) {
        // const status = err?.response?.data?.statusCode;
        // const serverMessage = err?.response?.data?.message;

        // let toastMessage = "Something went wrong.";

        // if (status === 404) {
        //     toastMessage = serverMessage || "Document not found.";
        // } else if (status === 500) {
        //     toastMessage = serverMessage || "Internal server error.";
        // } else if (serverMessage) {
        //     toastMessage = serverMessage;
        // }

        console.error(`Document error: ${err}`);
        // toast.error(`Document error:  ${toastMessage}`);
    }
}


export const getTitleForDocType = (subType) => {
    switch (subType?.toLowerCase()) {
        case "self-photo": return "Borrower Photo";
        case "self-photo-cob": return "Co-Borrower Photo";
        case "borrower-ro-inside-shop": return "Borrower RO Inside Shop";
        case "borrower-inside-residence": return "Borrower Inside Residence";
        case "self-ro-photo": return "Borrower Photo with RO";
        case "self-ro-photo-cob": return "Co-Borrower Photo with RO";
        case "self-video": return "Borrower Video";
        case "pan": return "PAN";
        case "aadhaar": return "Aadhaar";
        case "voters-id": return "Voter's ID";
        case "other-kyc": return "Other KYC";
        case "audio-household": return "Audio Household";
        case "audio-business": return "Audio House Recommendation";
        case "pan-cob": return "Co-borrower PAN";
        case "aadhaar-cob": return "Co-borrower Aadhaar";
        case "voters-id-cob": return "Co-borrower Voter's Id";
        case "other-kyc-cob": return "Co-borrower Other KYC";
        case "residence-picture": return "Home Photo";
        case "meter": return "With Meter";
        case "full-front-face": return "Full Front Face";
        case "inside-residence": return "Inside Residence";
        case "any-other-residence": return "Any Other Residence";
        case "residence-video": return "Residence Video";
        case "self-business-photo": return "Borrower Photo with Business";
        case "self-residence-photo": return "Borrower with Residence";
        case "business-photo": return "Business Photo";
        case "business-audio": return "Business Audio";
        case "bm-audio": return "Audio";
        case "udyam": return "UDHYAM";
        case "ser": return "SER";
        case "gst": return "GST";
        case "sales": return "SALES";
        case "business-expenses": return "Business Expenses";
        case "stock": return "Stock";
        case "purchase-bill": return "Purchase Bill";
        case "business-assets": return "Business Assets";
        case "bank-statement": return "Bank Statement";
        case "loan-agreement": return "Loan Agreement";
        case "pdc": return "PDC";
        case "sanction-letter": return "Sanction Letter";
        case "acceptance-video": return "Acceptance Video";
        case "any-other": return "Any Other Photo";
        case "any-other-cob": return "Co-Borrower Any Other Photo";
        case "shop-full-front-face": return "Shop Full Front Face";
        case "inside-shop-with-stock": return "Inside Shop With Stock";
        case "shop-with-approach-road": return "Shop With Approach Road";
        case "shop-with-sign-board": return "Shop With Sign Board";
        case "shop-video": return "Shop Video";
        case "any-other-business": return "Any Other Business Photo";
        case "photo-capture-by-bm": return "Photo Captured By BM";
        case "any-other-photo-bm": return "Any Other Photo Captured By BM";
        case "shop-photo-with-bc-and-signboard": return "Shop Photo With BCM And Signboard";
        case "borrower-photo-with-bcm": return "Borrower Photo With BCM";
        case "residence-photo-with-bcm": return "Residence Photo With BCM";
        case "stock-photo": return "Stock Photo";
        case "additional-stock-photos": return "Additional Stock Photos";
        case "other-photos": return "Other Photos";
        case "supplier-pic": return "Supplier Photo";
        case "supplier-video": return "Supplier Video";
        case "guarantor-aadhaar-card": return "Guarantor Aadhaar Card";
        case "bank-statement-borrower": return "Borrower Bank Statement";
        case "cob-photo-by-bm": return "BM Photo with Co-Borrower";
        default: return "Photo";
    }
};

export const maskNumber = (numberStr) => {
    if (!numberStr) return "";

    const cleaned = numberStr?.replace(/\s+/g, ''); // remove spaces if any
    const visibleDigits = 4;
    const maskedLength = cleaned.length - visibleDigits;

    // Mask all but last 4
    const maskedSection = '*'.repeat(maskedLength);
    const visibleSection = cleaned.slice(-visibleDigits);
    const fullMasked = maskedSection + visibleSection;

    // Group into chunks of 4
    const grouped = fullMasked.match(/.{1,4}/g)?.join(' ') || '';
    return grouped;
}

export const maskPAN = (pan) => {
    if (!pan || pan.length !== 10) return "";

    const firstTwo = pan.slice(0, 2);      // e.g., AB
    const lastThree = pan.slice(7);        // e.g., 4F

    return `${firstTwo}*****${lastThree}`;
}

export const getDocKey = (subtype) => {
    if (["aadhaar", "aadhaar-cob"].includes(subtype)) return "aadharCard";
    if (["pan", "pan-cob"].includes(subtype)) return "panCard";
    if (["voters-id", "voters-id-cob"].includes(subtype)) return "voterId";
    if (["driving-license", "driving-license-cob"].includes(subtype)) return "drivingLicense";
    if (["other-kyc", "other-kyc-cob"].includes(subtype)) return "otherKyc";
    if (["cb-report", "cb-report-cob"].includes(subtype)) return "cbReport";
    return null;
};

export const getViewDocumentUrl = async (doc) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    try {
        // const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/documents/view-doc/${doc.document_id}`,
        //     { headers });

        // const viewUrl = res?.data?.data?.data;

        // return {
        //     ...doc,
        //     document_url: viewUrl,
        // };
        const viewUrl = await getCachedViewUrl(doc.document_id);
        return {
            ...doc,
            document_url: viewUrl,
        };

    }
    catch (err) {
        const status = err?.response?.data?.statusCode;
        const serverMessage = err?.response?.data?.message;

        let toastMessage = "Something went wrong.";

        if (status === 404) {
            toastMessage = serverMessage || "Document not found.";
        } else if (status === 500) {
            toastMessage = serverMessage || "Internal server error.";
        } else if (serverMessage) {
            toastMessage = serverMessage;
        }

        toast.error(`${toastMessage}`);
        return null;
    }
}

export const openBase64InNewTab = (base64Data, mimeType = 'application/pdf') => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([byteNumbers], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, '_blank');

    setTimeout(() => URL.revokeObjectURL(blobUrl), 15000);
}
